import React from 'react'
import PropTypes from 'prop-types'
import AutoRenewalToggle from './AutoRenewalToggle'

const propTypes = {
  autorenews: PropTypes.bool.isRequired,
  handleCancelAutoRenewal: PropTypes.func.isRequired,
  membershipExpirationDate: PropTypes.string.isRequired,
  membershipId: PropTypes.string.isRequired,
}

function AutoRenewalHeader({
  autorenews,
  handleCancelAutoRenewal,
  membershipExpirationDate,
  membershipId,
}) {
  return (
    <header className="with-actions">
      <div className="icon-and-header">
        <img
          src="/assets/images/icons/with-background/ST_YIcon_Auto-renew.svg"
          alt=""
          className="icon"
        />
        <h2>Auto Renewal</h2>
      </div>
      <AutoRenewalToggle
        autorenews={autorenews}
        handleCancelAutoRenewal={handleCancelAutoRenewal}
        membershipExpirationDate={membershipExpirationDate}
        membershipId={membershipId}
      />
    </header>
  )
}

AutoRenewalHeader.propTypes = propTypes

export default AutoRenewalHeader
